import {
  Button,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { IPermission } from "models/permissions";

import { useState } from "react";
import { useTranslation } from "react-i18next";

const PermissionTable: React.FC<{
  permissions: IPermission[];
  onSubmit: (values: any) => void;
}> = ({ permissions, onSubmit }) => {
  const [permissionList, setPermissionList] = useState(permissions);
  const [isDirty, setIsDirty] = useState(false);
  const { t } = useTranslation();
  const handleCheckboxChange = (
    permissionId: number,
    permissionType: keyof IPermission
  ) => {
    const updatedPermissions = permissionList.map((permission) => {
      if (permission.permissionId === permissionId) {
        if(permissionType === 'hasFullControl'){
          return {
            ...permission,
            hasFullControl: !permission.hasFullControl,
            hasDeletePermission: !permission.hasFullControl ,
            hasModifyPermission: !permission.hasFullControl,
            hasReadPermission: !permission.hasFullControl
          };
        }
        return {
          ...permission,
          [permissionType]: !permission[permissionType],
        };
      }
      return permission;
    });
    setPermissionList(updatedPermissions);
    setIsDirty(true); // Mark form as dirty when changes are made
  };

  const handleSubmit = () => {
    onSubmit(permissionList);
    setIsDirty(false);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{`${t("T_permission_name")}`}</TableCell>
            <TableCell>{`${t("T_permission_description")}`}</TableCell>
            <TableCell align="center">{t("T_full_control")}</TableCell>
            <TableCell align="center">{t("T_read")}</TableCell>
            <TableCell align="center">{t("T_modify")}</TableCell>
            <TableCell align="center">{t("T_delete")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {permissionList.map((permission) => (
            <TableRow key={permission.permissionId}>
              <TableCell>{permission.permissionName}</TableCell>
              <TableCell>{permission.permissionDesc}</TableCell>
              <TableCell align="center">
                <Checkbox
                  checked={permission.hasFullControl ?? false}
                  onChange={() =>
                    handleCheckboxChange(
                      permission.permissionId,
                      "hasFullControl"
                    )
                  }
                />
              </TableCell>
              <TableCell align="center">
                <Checkbox
                  checked={(permission.hasReadPermission )  ?? false}
                  disabled={permission.hasFullControl}
                  onChange={() =>
                    handleCheckboxChange(
                      permission.permissionId,
                      "hasReadPermission"
                    )
                  }
                />
              </TableCell>
              <TableCell align="center">
                <Checkbox
                  checked={permission.hasModifyPermission ?? false}
                  disabled={permission.hasFullControl}
                  onChange={() =>
                    handleCheckboxChange(
                      permission.permissionId,
                      "hasModifyPermission"
                    )
                  }
                />
              </TableCell>
              <TableCell align="center">
                <Checkbox
                  checked={permission.hasDeletePermission ?? false}
                  disabled={permission.hasFullControl}
                  onChange={() =>
                    handleCheckboxChange(
                      permission.permissionId,
                      "hasDeletePermission"
                    )
                  }
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={!isDirty}
          onClick={handleSubmit}
          style={{ marginTop: "20px", borderRadius: 0 }}
        >
          {isDirty ? t("T_submit_changes") : t("T_no_changes")}
        </Button>
      </div>
    </TableContainer>
  );
};
export default PermissionTable;
